import { useNavigate } from 'react-router-dom';
import { formatDate, formatRecordType, getRecordTypeColor } from '../lib/utils';
import { ExpiryAlert } from '../types/index';
import { ExpiryBadge } from './ExpiryBadge';

interface AlertRowProps {
  alert: ExpiryAlert
}

export function AlertRow({ alert }: AlertRowProps) {
  const navigate = useNavigate()

  return (
    <tr className="border-b border-gray-200 hover:bg-gray-50">
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="flex flex-col">
          <p className="font-medium text-gray-900">{alert.customer_name}</p>
          <p className="text-sm text-gray-600">{alert.customer_phone}</p>
        </div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
        {alert.vehicle_reg || '—'}
      </td>
      <td className="px-6 py-4 whitespace-nowrap">
        <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold ${getRecordTypeColor(alert.record_type)}`}>
          {formatRecordType(alert.record_type)}
        </span>
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
        {alert.reference}
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
        {formatDate(alert.expiry_date)}
      </td>
      <td className="px-6 py-4 whitespace-nowrap">
        <ExpiryBadge days={alert.days_remaining} />
      </td>
    </tr>
  )
}
